export default {
  id: null,
  funcionarioId: null,
  dtInicioGiroCarteira: null,
  qtdVisitasPf: null,
  qtdVisitasPj: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/girocarteiramodel.js